import React from 'react';
import cn from 'classnames';
import { noop } from 'lodash';

import S from 'constants/string.const';
import { withTheme } from 'providers/Theme.provider';
import alwaysEmptyString from 'utils/functions/nullary/alwaysEmptyString.util';
import alwaysTrue from 'utils/functions/nullary/alwaysTrue.util';

import CN from './InputField.module.scss';

class InputField extends React.Component {
  static defaultProps = {
    readOnly: false,
    disabled: false,
    tableInputField: false,
    errorMessage: S.empty,
    onChangeHandler: noop,
    onBlurHandler: noop,
    onKeyUpHandler: noop,
    validateChange: alwaysTrue,
    validateBlur: alwaysEmptyString,
  };
  emailElementRef;

  constructor(props) {
    super(props);
    this.state = {
      inputValue: this.props.data.inputValue,
      errorMessage: '',
      touched: false,
    };
    this.emailElementRef = React.createRef();
  }

  componentDidMount() {
    // FIXME: UserEmail is too specific chcek in such generic component
    if (this.emailElementRef && this.emailElementRef.current && this.props.data.id === 'UserEmail') {
      this.emailElementRef.current.focus();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const nextValue = nextProps?.data?.inputValue;

    if (nextProps.tableInputField && nextValue !== this.state.inputValue) {
      this.setState({ inputValue: nextValue });
    }
  }
  onChange = (event) => {
    const { onChangeHandler, validateBlur } = this.props;
    const { touched } = this.state;
    const { value, id } = event.target;

    this.setState({ inputValue: value }, () => {
      if (onChangeHandler) {
        onChangeHandler(value, id);
      }
    });

    if (validateBlur && touched) {
      this.setState({ errorMessage: validateBlur(value) });
    }
  };

  onBlur = (event) => {
    const { validateBlur, onBlurHandler } = this.props;
    const { touched } = this.state;
    const { id, value } = event.target;

    if (validateBlur) {
      this.setState({ errorMessage: validateBlur(value) });
    }

    if (onBlurHandler) {
      onBlurHandler(value, id);
    }

    if (!touched) {
      this.setState({ touched: true });
    }
  };

  onKeyUp = (event) => {
    const { onKeyUpHandler } = this.props;

    if (onKeyUpHandler) {
      onKeyUpHandler(event);
    }
  };

  render() {
    const { inputValue, errorMessage: errorMessageFromState } = this.state;
    const { pwId, readOnly, disabled, errorMessage: errorMessageFromProps, isDarkMode, lightOnDark } = this.props;
    const { label, type, id, placeholder, inputMode } = this.props.data ?? {};

    const inputClasses = cn({
      [CN.input]: true,
      [CN.hasError]: errorMessageFromState,
    });

    return (
      <div
        data-bem="InputField--onboarding"
        data-input-id={id}
        className={cn({
          [CN.component]: true,
          [CN.dark]: isDarkMode,
          [CN.lightOnDark]: lightOnDark,
        })}
      >
        <div>
          {label && (
            <span data-bem="InputField__label-text" className={CN.labelName}>
              {S.space}
              {label}
            </span>
          )}

          <input
            data-bem="InputField__input"
            data-pw-id={pwId}
            ref={this.emailElementRef}
            readOnly={readOnly}
            disabled={disabled}
            className={inputClasses}
            id={id}
            type={type}
            placeholder={placeholder}
            value={inputValue}
            onChange={this.onChange}
            onBlur={this.onBlur}
            onKeyUp={this.onKeyUp}
            autoComplete="off"
            inputMode={inputMode}
          />
        </div>

        <div className={CN.error}>{errorMessageFromState || errorMessageFromProps}</div>
      </div>
    );
  }
}

const InputFieldHoc = withTheme()(InputField);

export default InputFieldHoc;
